
import { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Assessment } from '@/types/assessment';
import Logo from '@/icons/Logo';
import PremiumSignupForm from './PremiumSignupForm';
import PremiumLoginForm from './PremiumLoginForm';

interface PremiumAuthPageProps {
  assessment: Assessment;
  onAuthSuccess: () => void;
}

export default function PremiumAuthPage({ assessment, onAuthSuccess }: PremiumAuthPageProps) {
  const [mode, setMode] = useState<'login' | 'signup'>('login');

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-background to-muted p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="space-y-1 text-center">
          <div className="flex justify-center mb-2">
            <Logo className="h-10 w-10" />
          </div>
          <CardTitle className="text-2xl font-bold">
            {assessment.title}
          </CardTitle>
          <CardDescription>
            {mode === 'signup'
              ? 'Create an account to access the premium assessment'
              : 'Sign in to continue your premium assessment'}
          </CardDescription>
          
          {/* Toggle between signup and login */}
          <div className="flex items-center justify-center gap-1 pt-2">
            <Button
              variant={mode === 'signup' ? 'default' : 'ghost'}
              size="sm"
              onClick={() => setMode('signup')}
              className="rounded-full"
            >
              Sign Up
            </Button>
            <Button
              variant={mode === 'login' ? 'default' : 'ghost'}
              size="sm"
              onClick={() => setMode('login')}
              className="rounded-full"
            >
              Login
            </Button>
          </div>
        </CardHeader>
        <CardContent>
          {mode === 'signup' ? (
            <PremiumSignupForm
              assessmentSlug={assessment.slug}
              onSuccess={onAuthSuccess}
              onSwitchToLogin={() => setMode('login')}
            />
          ) : (
            <PremiumLoginForm
              assessmentSlug={assessment.slug}
              onSuccess={onAuthSuccess}
              onSwitchToSignup={() => setMode('signup')}
            />
          )}
        </CardContent>
      </Card>
    </div>
  );
}
